<template>
  <div></div>
</template>
<script>
import editModal from "@/components/users/edit/editModal.vue";
import { showModal } from "@/common/modal.service.js";
export default {
  created() {
    showModal({
      props: {
        userData: this.$route.meta.data,
      },
      width: "large",
      component: editModal,
      hasModalCard: true,
      parent: this,
      onCancel: () => this.$router.push(`/users/${this.$route.params.id}`),
      events: {
        close: e => console.log("Closed via button: ", e),
      },
    });
  },
};
</script>
